import { render, staticRenderFns } from "./student_form_fill_up_subject.vue?vue&type=template&id=cb72e6de&"
import script from "./student_form_fill_up_subject.vue?vue&type=script&lang=js&"
export * from "./student_form_fill_up_subject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports